import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollToDirective } from './scroll-to.directive';
import { ScrollToService } from './scroll-to.service';
var ScrollToModule = (function () {
    function ScrollToModule() {
    }
    /**
     * Guaranteed singletons for provided Services across App.
     *
     * @return 				An Angular Module with Providers
     */
    ScrollToModule.forRoot = function () {
        return {
            ngModule: ScrollToModule,
            providers: [
                ScrollToService
            ]
        };
    };
    ScrollToModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        ScrollToDirective
                    ],
                    exports: [
                        ScrollToDirective
                    ]
                },] },
    ];
    /** @nocollapse */
    ScrollToModule.ctorParameters = function () { return []; };
    return ScrollToModule;
}());
export { ScrollToModule };
//# sourceMappingURL=scroll-to.module.js.map


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/@nicky-lenaers/ngx-scroll-to/scroll-to.module.js
// module id = ../../../../@nicky-lenaers/ngx-scroll-to/scroll-to.module.js
// module chunks = vendor